'use strict'

/**
 * MODULE AJAX
 * Enregistre des appels AJAX à exécuté plus tard dans un workflow (ex: connexion utilisateur)
 */

/**
 * Appel AJAX en fin de workflow
 * @param {function} a Callback
 */
function CallLast(a) {
    $.ajax({
        url: window.LastCallurl,
        data: window.LastCalldata,
        success: function (data) {
            if (window.LastSuccess != null) {
                window.LastSuccess(data)
            }

            if (a != null) {
                a()
            }
        }
    })
}

/**
 * Enregistre l'url, le payload et une callback pour un appel AJAX en fin de workflow
 * @param {function} a Callback
 */
function SaveLastCall(url, data, onSuccess) {
    window.LastCallurl = url
    window.LastCalldata = data
    window.LastSuccess = onSuccess
}

export default {
    CallLast: CallLast,
    SaveLastCall: SaveLastCall
}
